<my-videos-list
  [getVideosObservableFunction]="getVideosObservableFunction"
  [getSyndicationItemsFunction]="getSyndicationItemsFunction"
  [baseRouteBuilderFunction]="baseRouteBuilderFunction"

  [title]="title"
  [titleTooltip]="titleTooltip"

  [defaultSort]="defaultSort"
  [defaultScope]="defaultScope"

  [displayFilters]="true"
  [displayModerationBlock]="true"

  [loadUserVideoPreferences]="true"
  [groupByDate]="groupByDate"

  [disabled]="disabled"

  (filtersChanged)="onFiltersChanged($event)"
>
</my-videos-list>
